import Vue from 'vue';
import { State } from '@/stores/enquiries/state';
import { MutationTree } from 'vuex';
import { Enquiry } from '@/models/enquiry';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setAllEnquiries = (state: State, enquiries: Array<Enquiry>) => {
        state.allEnquiries = enquiries;
    }
    public setAllEnquiriesPage = (state: State, page: number) => {
        state.allEnquiriesPageNumber = page;
    }
    public setAllEnquiriesPageSize = (state: State, pageSize: number) => {
        state.allEnquiriesPageSize = pageSize;
    }
    public setAllEnquiriesTotalPages = (state: State, pageCount: number) => {
        state.allEnquiriesTotalPages = pageCount;
    }
    public setAllEnquiriesTotal = (state: State, totalRecords: number) => {
        state.allEnquiriesTotal = totalRecords;
    }
    public setAllEnquiriesKeyword = (state: State, keyword: string | null) => {
        state.allEnquiriesKeyword = keyword;
    }
    public setAllEnquiriesFilterStatus = (state: State, filterStatus: number | string | null) => {
        state.allEnquiriesFilterStatus = filterStatus;
    }
    public setAllEnquiriesFrom = (state: State, from: string | null) => {
        state.allEnquiriesFrom = from;
    }
    public setAllEnquiriesTo = (state: State, to: string | null) => {
        state.allEnquiriesTo = to;
    }
    public setMyEnquiries = (state: State, enquiries: Array<Enquiry>) => {
        state.myEnquiries = enquiries;
    }
    public setMyEnquiriesPage = (state: State, page: number) => {
        state.myEnquiriesPageNumber = page;
    }
    public setMyEnquiriesPageSize = (state: State, pageSize: number) => {
        state.myEnquiriesPageSize = pageSize;
    }
    public setMyEnquiriesTotalPages = (state: State, pageCount: number) => {
        state.myEnquiriesTotalPages = pageCount;
    }
    public setMyEnquiriesTotal = (state: State, totalRecords: number) => {
        state.myEnquiriesTotal = totalRecords;
    }
    public setMyEnquiriesKeyword = (state: State, keyword: string | null) => {
        state.myEnquiriesKeyword = keyword;
    }
    public setMyEnquiriesFilterStatus = (state: State, filterStatus: number | string | null) => {
        state.myEnquiriesFilterStatus = filterStatus;
    }
    public setMyEnquiriesFrom = (state: State, from: string | null) => {
        state.myEnquiriesFrom = from;
    }
    public setMyEnquiriesTo = (state: State, to: string | null) => {
        state.myEnquiriesTo = to;
    }
}
